import {logout as apiLogout} from '../../../packages/api/index'

import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Disconnect = ({ className, toggleModal, logout }) => (
  <button
    type="button"
    className={className}
    onClick={() => {
      toggleModal();
      apiLogout().then(() => logout())
    }}
  >
    <ExitToAppIcon className="defaultWhite" />
    <p>Déconnexion</p>
  </button>
);

Disconnect.propTypes = {
  className: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

export default styled(Disconnect)`
  display: flex;
  align-items: center;
  background: hsl(27, 86%, 78%);
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  cursor: pointer;
  p {
    margin-left: 1rem;
    color: white;
  }
`;
